import React from "react";
import { useMutation } from "@apollo/client";
import PropTypes from "prop-types";
import GroupPropType from "src/custom-prop-types/group";
import { updateGroupName as updateGroupNameMutation } from "src/pages/TeamDetailPage/team.graphql";
import eventBus, { EVENTS } from "src/services/eventEmitter";
import TeamNameEditor from "./TeamNameEditor";

const TeamNameEditorContainer = ({ team, color = "white" }) => {
  const [updateGroupName] = useMutation(updateGroupNameMutation);

  const updateName = async (newName) => {
    const response = await updateGroupName({
      variables: {
        groupId: team.id,
        name: newName,
      },
    });

    eventBus.emit(EVENTS.GROUP_RENAMED, response.data.result);
  };

  return <TeamNameEditor team={team} updateName={updateName} color={color} />;
};

TeamNameEditorContainer.propTypes = {
  team: GroupPropType.isRequired,
  color: PropTypes.string,
};

export default TeamNameEditorContainer;
